import { Close } from '@mui/icons-material';
import TabContext from '@mui/lab/TabContext';
import TabList from '@mui/lab/TabList';
import TabPanel from '@mui/lab/TabPanel';
import {
    Button,
    Checkbox,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    Divider,
    FormControlLabel,
    IconButton,
    List,
    ListItem,
    ListItemSecondaryAction,
    ListItemText,
    Stack,
    Switch,
    TextField,
    ToggleButton,
    ToggleButtonGroup,
    Typography,
} from '@mui/material';
import Tab from '@mui/material/Tab';
import { useFormik } from 'formik';
import React, { useEffect, useState } from 'react';
import { IMaskInput } from 'react-imask';
import AddImage from '../../../../components/AddImage';
import useDialog from '../../../../hooks/useDialog';
import useErrors from '../../../../hooks/useErrors';
import { useFetch } from '../../../../hooks/useFecth';
import server from '../../../../services/server';
import { useConfirm } from 'material-ui-confirm';

const PriceField = React.forwardRef(function PriceField(props, ref) {
    const { onChange, value, type, ...other } = props;
    return (
        <IMaskInput
            {...other}
            value={String(value)}
            inputRef={ref}
            onAccept={value => onChange(props.name, value)}
            mask={'R$ num'}
            unmask={true}
            blocks={{
                num: {
                    mask: Number,
                    scale: 2,
                    thousandsSeparator: '.',
                    radix: ',',
                },
            }}
        />
    );
});

function Edit({ id, mutate }) {
    const { data } = useFetch(`plans/${id}`);
    return <Form data={data} mutate={mutate} />;
}

function ListProductsKit({ selected = [], setFieldValue }) {
    const { data, error } = useFetch(`additional`, { params: { paged: false, status: true } });

    if (error) return null;

    function handleSelect(id) {
        if (selected.includes(id)) {
            const newlist = selected.filter(i => i !== id);
            setFieldValue('product_kit', newlist);
        } else {
            setFieldValue('product_kit', [...selected, id]);
        }
    }

    return (
        <List>
            <>
                <Divider sx={{ mb: 2 }}>Produtos de customização</Divider>
                {Boolean(data) &&
                    Array.isArray(data) &&
                    data
                        ?.filter(item => item.type === 'custom')
                        .map(item => (
                            <>
                                <ListItem>
                                    <ListItemText primary={item.name} />
                                    <ListItemSecondaryAction>
                                        <Checkbox onChange={(e, v) => handleSelect(item.id)} checked={selected.includes(item.id)} />
                                    </ListItemSecondaryAction>
                                </ListItem>
                                <Divider />
                            </>
                        ))}
                {/*   <Divider sx={{ mb: 2, mt: 3 }}>Produtos adicionais</Divider>
               {Boolean(data) &&
                    Array.isArray(data) &&
                    data
                        ?.filter(item => item.type === 'additional')
                        .map(item => (
                            <>
                                <ListItem>
                                    <ListItemText primary={item.name} />
                                    <ListItemSecondaryAction>
                                        <Checkbox onChange={(e, v) => handleSelect(item.id)} checked={selected.includes(item.id)} />
                                    </ListItemSecondaryAction>
                                </ListItem>
                                <Divider />
                            </>
                        ))} */}
            </>
        </List>
    );
}

function PlanPriceTableTab({ planId, setErrors, enqueueSnackbar }) {
    const [formValues, setFormValues] = useState({ id: null, numberLife: '', price: '' });
    const [isSaving, setIsSaving] = useState(false);
    const { data, mutate, isLoading } = useFetch(planId ? `plans/${planId}/price-table` : null, {
        params: { planId },
    });
 

    console.log('data table : ' , data)
    const rows = Array.isArray(data) ? data : [];

    function handleChange(name, value) {
        setFormValues(prev => ({ ...prev, [name]: value }));
    }

    function clearForm() {
        setFormValues({ id: null, numberLife: '', price: '' });
    }

    async function handleSubmitPriceTable() {
        try {
            if (!formValues.numberLife || Number(formValues.numberLife) <= 0) {
                enqueueSnackbar('Informe um valor válido para "Até vidas".', { variant: 'warning' });
                return;
            }

            if (!formValues.price || Number(formValues.price) <= 0) {
                enqueueSnackbar('Informe um preço válido.', { variant: 'warning' });
                return;
            }

            setIsSaving(true);

            const payload = {
                planId: Number(planId),
                numberLife: Number(formValues.numberLife),
                price: Number(formValues.price),
            };

            if (formValues.id) {
                await server.put(`plans/${planId}/price-table/${formValues.id}`, payload);
                enqueueSnackbar('Faixa de preço alterada com sucesso.', { variant: 'success' });
            } else {
                await server.post(`plans/${planId}/price-table`, payload);
                enqueueSnackbar('Faixa de preço adicionada com sucesso.', { variant: 'success' });
            }

            clearForm();
            await mutate();
        } catch (error) {
            setErrors(error);
        } finally {
            setIsSaving(false);
        }
    }

    return (
        <Stack spacing={2}>
            <Typography variant="body2" color="text.secondary">
                Configure valores por faixa de vidas do plano.
            </Typography>

            <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
                <TextField
                    label="Até vidas"
                    name="numberLife"
                    type="number"
                    sx={{ width: '50%' }}
                    value={formValues.numberLife}
                    onChange={e => handleChange('numberLife', e.target.value)}

                />
                <TextField
                    label="Preço"
                    name="price"
                    value={String(formValues.price)}
                    onChange={(name, value) => handleChange(name, value)}
                    sx={{ width: '50%' }}

                    InputProps={{
                        inputComponent: PriceField,
                    }}
                    InputLabelProps={{
                        shrink: true / false,
                    }}
                />
                <Button variant="contained" sx={{ width: '20%' }} onClick={handleSubmitPriceTable} disabled={isSaving}>
                    {formValues.id ? 'Salvar alteração' : 'Adicionar'}
                </Button>
                {formValues.id && (
                    <Button variant="outlined" onClick={clearForm} disabled={isSaving}>
                        Cancelar
                    </Button>
                )}
            </Stack>

            <Divider />

            <Typography variant="subtitle2">Faixas cadastradas</Typography>
            <List sx={{ border: theme => `1px solid ${theme.palette.divider}`, borderRadius: 1, p: 0 }}>
                {!isLoading && rows.length === 0 && (
                    <ListItem>
                        <ListItemText primary="Nenhuma faixa cadastrada ainda." />
                    </ListItem>
                )}

                {rows.map(item => (
                    <React.Fragment key={item.id}>
                        <ListItem>
                            <ListItemText
                                primary={`Até ${item.numberLife} vidas`}
                                secondary={`Preço: R$ ${Number(item.price || 0).toLocaleString('pt-BR', {
                                    minimumFractionDigits: 2,
                                    maximumFractionDigits: 2,
                                })}`}
                            />
                            <ListItemSecondaryAction>
                                <Button
                                    size="small"
                                    onClick={() => {
                                        setFormValues({
                                            id: item.id,
                                            numberLife: item.numberLife ?? '',
                                            price: item.price ?? '',
                                        });
                                    }}
                                >
                                    Alterar
                                </Button>
                            </ListItemSecondaryAction>
                        </ListItem>
                        <Divider />
                    </React.Fragment>
                ))}
            </List>
        </Stack>
    );
}

function Form({ data, mutate }) {
    const { open, handleClose } = useDialog('#plans');
    const { setErrors, enqueueSnackbar } = useErrors();
    const [tab, setTab] = useState('#dados');
    const confirm = useConfirm();

    const { values, handleSubmit, handleChange, setFieldValue, touched, errors, setValues, isSubmitting } = useFormik({
        initialValues: {
            name: '',
            description: '',
            // additionalType: '',
            price: 0,
            // disccount: 0,
            numberLifes: 1,
            image: '',
            functions: [],
            product_kit: [],
            additionals: [],
            status: '',
        },

        onSubmit: async (values, { setSubmitting }) => {
            try {
                setSubmitting(true);
                if (!values.id) {
                    await server.post(`plans`, values);
                    enqueueSnackbar(`Plano ${values.name} adicionado`);
                    // navigate(`#plans|${data.data.id}`);

                    handleClose();
                } else {
                    await server.put(`plans/${values.id}`, values);
                    enqueueSnackbar(`Plano ${values.name} alterado`);
                    handleClose();
                }
                await mutate();
            } catch (error) {
                setErrors(error);
            } finally {
                setSubmitting(false);
                //handleClose();
            }
        },
    });

    useEffect(() => {
        if (data) {
            setValues({ ...data, additionals: data?.additionals || [], functions: data?.functions || [], product_kit: data?.Kit?.map(i => i.productId, []) }, true);
        }
    }, [data, setValues]);

    // Função chamada quando a exclusão é confirmada
    const handleDeleteConfirm = async () => {
        try {
            await confirm({ title: 'Removendo registro', description: 'Deseja remover o plano ?' });
            await server.delete(`plans/${values.id}`);
            enqueueSnackbar('Plano excluído com sucesso', { variant: 'success' });
            handleClose();
            await mutate();
        } catch (error) {
            setErrors(error);
        }
    };

    // Se functions não tiver 'benefit', zera additionals
    useEffect(() => {
        if (values && Array.isArray(values?.functions) && !values?.functions.includes('benefit')) {
            setFieldValue('additionals', []);
        }
        // eslint-disable-next-line
    }, [values?.functions]);

    return (
        <>
            <TabContext value={tab}>
                <Dialog open={open} onClose={handleClose} maxWidth="md" fullWidth>
                    <Stack direction="row" justifyContent="space-between" alignItems="center">
                        <DialogTitle>{data ? 'Editando plano' : 'Adicionando plano'}</DialogTitle>
                        <IconButton onClick={handleClose} aria-label="close" sx={{ marginRight: 2 }}>
                            <Close />
                        </IconButton>
                    </Stack>
                    <Divider />
                    {values.id && (
                        <>
                            <TabList onChange={(e, tab) => setTab(tab)}>
                                <Tab value="#dados" label="Dados do plano" />
                                <Tab value="#tabela-precos" label="Tabela de preços" />
                                {/* <Tab value="#adicionais" label="Produtos do plano" /> */}
                            </TabList>
                            <Divider />
                        </>
                    )}
                    <DialogContent dividers sx={{ p: 0 }}>
                        <TabPanel value="#dados">
                            <Stack spacing={2}>
                                {values.id && (
                                    <AddImage
                                        value={values.previewImage || values.image}
                                        onChange={setFieldValue}
                                        name="image"
                                        label="Adicionar imagem"
                                    />
                                )}
                                <TextField
                                    label="Nome do plano"
                                    name="name"
                                    value={values.name}
                                    onChange={handleChange}
                                // error={Boolean(touched.name && errors.name)}
                                // helperText={touched.name && errors.name}
                                />
                                <TextField
                                    label="Descrição do plano"
                                    name="description"
                                    value={values.description}
                                    onChange={handleChange}
                                    error={Boolean(touched.description && errors.description)}
                                    helperText={touched.description && errors.description}
                                />

                                <ToggleButtonGroup
                                    fullWidth
                                    onChange={(e, value) => setFieldValue('functions', value)}
                                    value={values.functions}
                                    name="functions"
                                >
                                    <ToggleButton color="success" sx={{ fontWeight: 'bold', fontSize: 11 }} value="cupons">
                                        Rede de descontos
                                    </ToggleButton>
                                    <ToggleButton color="success" sx={{ fontWeight: 'bold', fontSize: 11 }} value="vouchers">
                                        Rede local
                                    </ToggleButton>
                                    <ToggleButton color="success" sx={{ fontWeight: 'bold', fontSize: 11 }} value="cashback">
                                        Cashback
                                    </ToggleButton>
                                    {/* <ToggleButton color="success"  sx={{ fontWeight: 'bold',fontSize: 11 }} disabled={values?.functions?.includes('custom_app')} value="multi_app">
                                        App Seu Clube
                                    </ToggleButton>
                                    <ToggleButton color="success"  sx={{ fontWeight: 'bold',fontSize: 11 }} disabled={values?.functions?.includes('multi_app')} value="custom_app">
                                        App Personalizado
                                    </ToggleButton> */}
                                    <ToggleButton color="success" sx={{ fontWeight: 'bold', fontSize: 11 }} value="reseller">
                                        Revenda/Página de vendas
                                    </ToggleButton>
                                    <ToggleButton color="success" sx={{ fontWeight: 'bold', fontSize: 11 }} value="benefit">
                                        Gestão de benefícios
                                    </ToggleButton>
                                </ToggleButtonGroup>

                                {values?.functions?.includes('benefit') && (
                                    <ToggleButtonGroup
                                        fullWidth
                                        onChange={(e, value) => setFieldValue('additionals', value)}
                                        value={values.additionals}
                                        name="additionals"
                                    >
                                        <ToggleButton color="success" sx={{ fontWeight: 'bold', fontSize: 11 }} value="telemedicina">
                                            Telemedicina
                                        </ToggleButton>
                                        <ToggleButton color="success" sx={{ fontWeight: 'bold', fontSize: 11 }} value="telepsicologia">
                                            Telepsicologia
                                        </ToggleButton>
                                        <ToggleButton color="success" sx={{ fontWeight: 'bold', fontSize: 11 }} value="seguro">
                                            Seguro de vida
                                        </ToggleButton>
                                        <ToggleButton color="success" sx={{ fontWeight: 'bold', fontSize: 11 }} value="telepet">
                                            Telepet
                                        </ToggleButton>
                                    </ToggleButtonGroup>
                                )}

                                {/* {values.id && ( */}
                                <>
                                    <TextField
                                        label="Preço"
                                        name="price"
                                        value={String(values.price)}
                                        onChange={setFieldValue}
                                        error={Boolean(touched.price && errors.price)}
                                        helperText={touched.price && errors.price}
                                        type="number"
                                        InputProps={{
                                            inputComponent: PriceField,
                                        }}
                                        InputLabelProps={{
                                            shrink: true / false,
                                        }}
                                    />
                                    {/* <TextField
                                        label="Número de vidas"
                                        name="numberLifes"
                                        value={values.numberLifes}
                                        onChange={handleChange}
                                        error={Boolean(touched.numberLifes && errors.numberLifes)}
                                        helperText={touched.numberLifes && errors.numberLifes}
                                        type="number"
                                    /> */}
                                </>
                            </Stack>
                        </TabPanel>
                        <TabPanel value="#adicionais">
                            <DialogContent>
                                {/* <Alert>Colocar aqui a lista de produtos adicionais ordenados por categoria</Alert> */}
                                <ListProductsKit selected={values?.product_kit} setFieldValue={setFieldValue} />
                            </DialogContent>
                        </TabPanel>
                        <TabPanel value="#tabela-precos">
                            <PlanPriceTableTab planId={values.id} setErrors={setErrors} enqueueSnackbar={enqueueSnackbar} />
                        </TabPanel>
                    </DialogContent>

                    <DialogActions>
                        {values.id && (
                            <>
                                <FormControlLabel
                                    title='Não mostrar nas opções de planos na proposta'
                                    control={<Switch checked={values.status} onChange={e => setFieldValue('status', e.target.checked)} />}
                                    label="Status"
                                />
                                <Button color="error" onClick={handleDeleteConfirm}>
                                    Excluir
                                </Button>
                            </>
                        )}
                        <Button variant="contained" onClick={handleSubmit} disabled={isSubmitting}>
                            Salvar
                        </Button>
                    </DialogActions>
                </Dialog>
            </TabContext>
        </>
    );
}

export default function DialogPlans({ mutate }) {
    const { open, id } = useDialog('#plans');
    if (open && id) return <Edit id={id} mutate={mutate} />;
    if (open) return <Form mutate={mutate} />;
}
